import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DefectAreaMaskStore {
  // Dim everything outside the center area where a defect can be located
  maskEnabled: boolean;
  toggleMask: () => void;
}

export const useDefectAreaMaskStore = create<DefectAreaMaskStore>()(
  persist(
    (set) => ({
      maskEnabled: true,
      toggleMask: () => set((state) => ({ maskEnabled: !state.maskEnabled })),
    }),
    {
      name: "vl-defect-area-mask",
      partialize: (state) => ({ maskEnabled: state.maskEnabled }),
    },
  ),
);
